import React from "react";
import HomeIcon from "@material-ui/icons/Home";
import Assessment from "@material-ui/icons/Assessment";
import PieChart from "@material-ui/icons/PieChart";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import Payment from "@material-ui/icons/Payment";
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EventNoteIcon from '@material-ui/icons/EventNote';
import DomainIcon from '@material-ui/icons/Domain';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import WorkIcon from '@material-ui/icons/Work';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import ApartmentIcon from '@material-ui/icons/Apartment';
import BallotIcon from '@material-ui/icons/Ballot';
import BusinessIcon from '@material-ui/icons/Business';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import PagesIcon from '@material-ui/icons/Pages';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PropTypes from "prop-types";

const iconMap = {
    accountcircle: <HomeIcon />,
    assessment: <Assessment />,
    piechart: <PieChart />,
    accountbalanceicon: <AccountBalanceIcon />,
    accountcircleicon: <AccountCircleIcon />,
    personaddicon: <PersonAddIcon />,
    payment: <Payment />,
    homeicon: <HomeIcon />,
    eventnoteicon: <EventNoteIcon />,
    domainicon: <DomainIcon />,
    mailoutlineicon: <MailOutlineIcon />,
    workicon: <WorkIcon />,
    callspliticon: <CallSplitIcon />,
    apartmenticon: <ApartmentIcon />,
    balloticon: <BallotIcon />,
    businessicon: <BusinessIcon />,
    cardgiftcardicon: <CardGiftcardIcon />,
    dashboardicon: <DashboardIcon />,
    datausageicon: <DataUsageIcon />,
    devicehubicon: <DeviceHubIcon />,
    pagesicon: <PagesIcon />,
};


const DynamicIcon = ({ iconName }) => {
    const icon = iconMap[iconName?.toLowerCase()];
    return icon || null;
};

DynamicIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
};

export default DynamicIcon;